import { useEffect, useState } from "react";
import { useAskAvailableAppointments } from "./useAskAvailableAppointments";
import { useViewAvailableAppointments } from "./useViewAvailableAppointments";
import { mapAvailableAppointmentList } from "../mappers/mapAvailableAppointmentList";

interface IParams {
    offerId: number;
}

export const useAvailableAppointments = (props: IParams) => {
    const { offerId } = props;
    const [shouldPoll, setShouldPoll] = useState(false);
    const [isPostCompleted, setIsPostCompleted] = useState(false);

    const { askAvailableAppointments, error: askError, isLoading: askIsLoading } = useAskAvailableAppointments({
        offerId,
    });

    const { availableAppointments, error: viewError, isLoading: viewIsLoading } = useViewAvailableAppointments({
        offerId,
        shouldPoll,
        isEnabled: isPostCompleted,
    });

    useEffect(() => {
        askAvailableAppointments((result) => {
            if (result) {
                // We need to wait for the post to complete before we can start polling, otherwise we will get a 404 error from backend
                setIsPostCompleted(true);
                setShouldPoll(true);
            }
        });
    }, [askAvailableAppointments]);

    return {
        dateList: mapAvailableAppointmentList(availableAppointments),
        error: askError ?? viewError,
        isLoading: askIsLoading || viewIsLoading,
    };
};
